import {Component, Inject, OnInit} from '@angular/core';
import {NetworkService} from "../../network.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Device} from "../../../model/device.model";
import {NodeModel} from "../../../model/node.model";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MomentDateAdapter} from "@angular/material-moment-adapter";
import {MY_FORMATS} from "../../../shared/util.service";

@Component({
    selector: 'app-device-dialog',
    templateUrl: './device-dialog.component.html',
    styleUrls: ['./device-dialog.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class DeviceDialogComponent implements OnInit {

  sites = [];
  devices: Device[] = [];
  offset:number = null;

  dataLoggerOnly = true; // Show loggers for rootnode (if there is no parent node)

  node:NodeModel;
  installedDeviceName = '';

  showReplace = false;

  constructor(
    private service: NetworkService,
    public dialogRef: MatDialogRef<DeviceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.node = this.data.item;
    this.installedDeviceName = this.node && this.node.device ? this.node.device : '';
    setTimeout(() => {this.initDialog()}, 500);
  }

  onReplaceBtnClick() {
    if (this.showReplace) {
      this.node.message = null;
    }
    this.showReplace = !this.showReplace;
  }

  initDialog() {
    this.node = this.data.item;
    this.dataLoggerOnly = !this.node.parent;
    this.service.getDeviceDialogData().subscribe((resp:any) => {
      if (resp) {
        if (resp.sites) {
          this.sites = resp.sites;
        }
        if (resp.devices) {
          this.devices = resp.devices.map(d => new Device(d));
        }
        if (resp.offset) {
          this.offset = resp.offset;
        }
      }
    })
  }

  onSaveClick() {
    //if (device.isValid()) {}
    this.service.saveNode(this.node).subscribe((resp:any) => {
      if (resp && resp.id) {
        this.service.notiService.open("Device successfully installed");
        // It was a replacement, reload tree
        if (this.showReplace) {
          window.location.reload();
        } else {
          this.dialogRef.close(new NodeModel(resp));
        }
      } else {
        this.service.notiService.open("Error during saving.");
        console.log(resp);
      }
    })
  }

  handleDelete() {
    this.service.deleteNode(this.node.id).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error)
      }
      if (resp.success) {
        this.service.notiService.open("Deleted");
        this.dialogRef.close({delete:true})
      } else {
        return this.service.notiService.open("Can not delete this.");
      }
    }, (error:any) => {
      console.log(error);
      return this.service.notiService.open("Can not delete this.");
    })
  }

  onConfirmDelete() {
    this.service.confirmAction().subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.handleDelete()
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onDateChange(prop) {
    this.node[prop] = this.node[prop].format('YYYY-MM-DD');
  }
}
